import React, { PureComponent } from "react";
import _ from "lodash";
import {
    Card,
    CardBody,
    Col,
    Button,
    ButtonToolbar,
    Container,
    Row,
    Table,
    Modal,
    Tooltip,
} from "reactstrap";
import Util from '../../../Common/util';
import API from '../../../Common/api';
import {
    MDBDataTable,

} from "mdbreact";

import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import $ from "jquery";
import { Field, reduxForm } from "redux-form";

import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { useMemo, useState } from 'react';
import { useTable, usePagination, useGlobalFilter, useSortBy, useRowSelect } from 'react-table';
import { useAsyncDebounce } from 'react-table';
import { Checkbox } from './Checkbox'

import LoadingOverlay from 'react-loading-overlay';
import { make_cols } from "./MakeColumns";
import {addAnalytics, paginationAnalytics} from '../../../Common/analytics';
import blackUploadIcon from '../../../../images/blackUploadIcon.svg';
import blueDownloadIcon from '../../../../images/blueDownloadIcon.svg';
import exportToCSVNew from '../../../Common/exportcsvnew';


const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const fileExtension = ".xlsx";

const exportToCSV = (csvData, fileName) => {
    const ws = XLSX.utils.json_to_sheet(csvData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
};

var data_type = "";
var unassign_arr = [];
var assign_arr = [];
class HorizontalForm extends PureComponent {
    static propTypes = {
        t: PropTypes.func.isRequired,
        handleSubmit: PropTypes.func.isRequired,
        reset: PropTypes.func.isRequired,
    };

    constructor() {
        super();
        this.getProductDetails = this.getProductDetails.bind(this);
        this.checkedSingle = this.checkedSingle.bind(this);
        this.checkAll = this.checkAll.bind(this);

        this.state = {
            stock_header: [
                { "Product": "", "Mrp": "", "Qty": "", "Stock Type": "" },
            ],
            showPassword: false,
            btnDisabled: false,
            approveLoading: false,
            loading: false,
            selectedLocation: "",
            location_list: [],
            SelectedBins: [],
            loadBinData: false,
            schemas: [],
            showFetchGRNData: false,
            successModal: false,
            modalCancel: false,
            isChecked: false,
            showFailedItem: false,
            selectedOptions: "",
            failed_message: "",
            changeStatus: "",
            alertMessage: "",
            messageModal: false,
            modalfailed: false,
            checkedAll: false,
            postsProduct: [],
            multiSelect: [],
            postsProduct: [],
            tableRowsGRN: [],
            tableRowsProduct: [],
            selectedFile: false,
            ErrorRowData: [],
            binData: [],
            options: [],
            newArrayData: [],
            newArrayData1: [],
            selectedUser: {},
            showAssignButton: true,
            showPrintButton: false,
            showSubmitBtn: false,
            value: "0",
            from_location: "",
            to_location: "",
            selectedBinAddress: "",
            all_binaddress: [],
            loading_overlay: false,
            file: {},
            responseModal: false,
            responseModalMsg: null,
            data: [],
            client: "",
            selectedFileType: "",
            error: "",
            loading_s: false,
            stn_id: "",
            prod_arr: [],
            selected_arr: [],
            filtered_orderData: "",
            alertmodal: false,

        };
    }



    componentDidMount() {
        this.getLocationList();
    }

    componentWillMount() {


        var cookieUsername = this.getCookie("token");
        var Location = this.getCookie("selectedLocation");
        var username = this.accessCookie("token");

        this.setState({
            userName: cookieUsername,
            selectedLocation: Location,
        });

        localStorage.setItem("userName", username);
    }



    accessCookie = (cookieName) => {
        var name = cookieName + "=";
        var allCookieArray = document.cookie.split(";");
        for (var i = 0; i < allCookieArray.length; i++) {
            var temp = allCookieArray[i].trim();
            if (temp.indexOf(name) == 0)
                return temp.substring(name.length, temp.length);
        }
        return "";
    }
    removeUploadedFile = () => {
        this.setState({ selectedFile: null, posts: [] });
    };

    getCookie = (cname) => {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(";");
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == " ") {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }
    checkAll() {
        if (this.state.isChecked === false) {
            this.setState({
                isChecked: true,
                showSelectedBin: true,
            });

            let newData = this.state.filtered_orderData.map((item) => ({
                ...item,
                isChecked: true,
            }));
            var arrayData = newData.filter(
                (item) => item.isChecked === true
            );

            this.setState({
                tableRowsProduct: this.assemblePostsProduct(newData),
                filtered_orderData: newData,

            });


        } else if (this.state.isChecked === true) {
            this.setState({
                isChecked: false,
                showSelectedBin: false,
            });

            let newData = this.state.filtered_orderData.map((item) => ({
                ...item,
                isChecked: false,
            }));
            var arrayData = newData.filter(
                (item) => item.isChecked === false
            );

            this.setState({
                tableRowsProduct: this.assemblePostsProduct(newData),
                filtered_orderData: newData,

            });


        }
    }

    checkedSingle(index, ischecked, orderid) {

        var arr = [];
        let newData = this.state.filtered_orderData;
        if (newData[index].isChecked === false) {
            newData[index].isChecked = true;
            data_type = "assign";
            assign_arr.push(orderid);

        } else if (newData[index].isChecked === true) {
            newData[index].isChecked = false;
            data_type = "unassign";
            unassign_arr.push(orderid);

        }

        this.setState({
            tableRowsProduct: this.assemblePostsProduct(newData),
            filtered_orderData: newData,

        });

    }


    getProductDetails() {
        this.setState({
            loading: true
        })
        addAnalytics('Stock Transfer', 'Stock Transfer Search Filter');

        API.get('/reverse-stock-transfer/products/?to_loc =' + this.state.to_location)

            .then((response) => response.data)

            .then((data) => {

                let UnAssignData = data.data.map((item) => ({
                    ...item,
                    isChecked: false,
                }));

                this.setState({
                    prod_arr: UnAssignData,
                    filtered_orderData: UnAssignData,
                    tableRowsProduct: this.assemblePostsProduct(UnAssignData),
                    isLoading: false,
                    genloading: false,
                    loading: false,
                });
            })

            .then(async () => {

            });
    }

    getLocationList = () => {

        const payload = {
            // location: this.state.selectedLocation,
            request_type: "warehouse_brand"
        };

        API.post('/product/product_master/v1/warehouse/dropdown/', { param: payload })

            .then((response) => response.data)

            .then((data) => {

                this.setState({ location_list: data.data });
            })

            .then(async () => {

            });
    }

    GenerateStockId = (loading_param) => {
        if (loading_param === "normal") {
            this.setState({
                loading_s: true,
                loading_s1: false,
                btnDisabled :true
            });
        } else {
            this.setState({
                loading_s1: true,
                loading_s: false,
                btnDisabled : true
            });
        }
    
        if (this.state.to_location === "") {
            this.alertToggle();
        } else {
            this.setState({
                approveLoading: true
            });
    
            const payload = {
                to_warehouse: this.state.to_location,
                products: assign_arr.length > 0 ? assign_arr : (this.state.posts || []),
                client: this.state.client,
            };
    
            addAnalytics('Stock Transfer', 'Create Stock Transfer', payload);
    
            API.post('/reverse-stock-transfer/sto-id/create/', { param: payload })
                .then((response) => response.data)
                .then((data) => {
                    if (data.success === true) {
                        this.setState({
                            success_message: data.message,
                            loading_s: false,
                            loading_s1 : false,
                            btnDisabled : false
                        });
                        this.successToggle();
                    } else {
                        this.setState({
                            failed_message: data.message,
                            approveLoading: false,
                            loading_s: false,
                            loading_s1 : false,
                            btnDisabled : false
                        });
                        this.failedToggle();
                    }
                })
                .catch((error) => {
    
                    let message = "Something went wrong.";
                    if (error.response && error.response.data && error.response.data.message) {
                        message = error.response.data.message;
                    }
    
                    this.setState({
                        failed_message: message,
                        approveLoading: false,
                        loading_s: false,
                        loading_s1: false,
                        btnDisabled : true
                    });
    
                    this.failedToggle();
                });
        }
    }
    
    
    handleFileUpload = (event) => {
        const file = event.target.files[0];
  
        if (file) {
          const expectedHeaders = [
            "Product",
            "Mrp",
            "Qty",
            "Stock Type"
          ];
  
          const keyMap = {
            "Product": "sku7_code",
            "Mrp": "mrp",
            "Qty": "quantity",
            "Stock Type": "zone_type"
          };
  
          const reader = new FileReader();
          reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];
  
            // Header validation
            const rawData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
            const headersFromFile = rawData[0].filter(h => h !== "S.NO"); // Ignore "S.NO" column
  
            const isValid = expectedHeaders.every(header => headersFromFile.includes(header)) &&
                            headersFromFile.length === expectedHeaders.length;
  
            if (!isValid) {
              this.setState({
                selectedFile: null,
                posts: [],
                fileError: "Please upload a valid template file.",
              });
              return;
            }
  
            // Transform data
            const jsonData = XLSX.utils.sheet_to_json(worksheet);
            const transformedData = jsonData.map(row => {
              const newRow = {};
              Object.keys(row).forEach(key => {
                if (keyMap[key]) {
                  newRow[keyMap[key]] = row[key];
                }
              });
              return newRow;
            });
  
            this.setState({
              selectedFile: file,
              posts: transformedData,
              fileError: null,
            });
            window.toggleNewModal = this.toggleAddItem;
  
          };
  
          reader.readAsArrayBuffer(file);
        }
        event.target.value = null;
      };


    successToggle = () => {
        this.setState((prevState) => ({ successModal: !prevState.successModal }));

        // window.location.reload();
    }

    successToggleOK = () => {
        this.setState((prevState) => ({ successModal: !prevState.successModal }));
        // window.location.reload();
        window.location.href = "/maintenance/stock_transfer"
    }

    failedToggle = () => {

        this.setState((prevState) => ({ modalfailed: !prevState.modalfailed }));
    }

    changeFromLocation = (e) => {
        this.setState({
            locationNotSelected: false,
            from_location: e.target.value,
        });
    };
    changeToLocation = (e) => {
        this.setState({
            locationNotSelected: false,
            to_location: e.target.value,
        });
    };
    onClientChange = (e) => {
        this.setState({
            client: e.target.value,
        })
    }
    alertToggle = () => {

        this.setState((prevState) => ({ alertmodal: !prevState.alertmodal }));
    }

    assemblePostsProduct = (posts) => {

        let postsProduct = posts.map((post, index) => {
            return {
                action: <span>er<input style={{ textAlign: 'center' }} className="table_td_checkbox" type="checkbox" value={post.isChecked} checked={post.isChecked} onChange={() => this.checkedSingle(index, post.isChecked, post.id)} /></span>,

                product_code: post.sku7_code,
                mrp: post.mrp,
                qty: post.quantity,
                zone_type: post.zone_type

            };
        });

        this.setState({
            genloading: false,

        })

        return postsProduct;
    };


    render() {
        const { handleSubmit, reset, t } = this.props;
        const {

            newArrayData,
            newArrayData1,

        } = this.state;

        const {
            successModal, modalfailed, alertmodal

        } = this.state;
        const uniqueZoneData1 = {};
        const uniqueZoneData = {};
        newArrayData.map((item) => {
            if (!uniqueZoneData[item.zone_id]) {
                uniqueZoneData[item.zone_id] = {
                    zoneId: item.zone_no,
                    zoneName: item.zone_code,
                    id: item.zone_id,
                    items: [],
                };
            }
            uniqueZoneData[item.zone_id].items.push(item);
        });

        newArrayData1.map((item) => {
            if (!uniqueZoneData1[item.zone_id]) {
                uniqueZoneData1[item.zone_id] = {
                    zoneId: item.zone_id,
                    zoneName: item.zone__zone_code,
                    items: [],
                };
            }
            uniqueZoneData1[item.zone_id].items.push(item);
        });

        const GROUPED_COLUMNS = [
            {
                Header: 'Product Code',
                accessor: 'sku7_code'
            },

            {
                Header: 'Mrp',
                accessor: 'mrp'
            },
            {
                Header: 'Quantity',
                accessor: 'quantity'
            },
            {
                Header: 'Stock Type',
                accessor: 'zone_type'
            },

        ]



        const GlobalFilter = ({ filter, setFilter }) => {
            const [value, setValue] = useState(filter)
            const onChange = useAsyncDebounce(value => {
                setFilter(value || undefined)
            }, 1000)
            return (
                <span >
                    {' '}
                    <input className="input_border"
                        value={value || ''}
                        placeholder="Search"
                        onChange={e => {
                            setValue(e.target.value);
                            onChange(e.target.value);


                        }}
                    />
                </span>
            )
        }
        const PaginationTable = () => {
            const columns = useMemo(() => GROUPED_COLUMNS, [])
            const data = useMemo(() => this.state.prod_arr, [])
            const {
                getTableProps,
                getTableBodyProps,
                headerGroups,
                rows,
                page,
                nextPage,
                previousPage,
                canPreviousPage,
                canNextPage,
                pageOptions,
                state,
                setGlobalFilter,
                gotoPage,
                pageCount,
                setPageSize,
                selectedFlatRows,
                prepareRow
            } = useTable(
                {
                    columns,
                    data,
                    initialState: { pageIndex: 0, pageSize: this.state.prod_arr.length },
                },

                useGlobalFilter,
                useSortBy,
                usePagination,
                useRowSelect,
                hooks => {
                    hooks.visibleColumns.push(columns => [
                        {
                            id: 'selection',
                            Header: ({ getToggleAllRowsSelectedProps }) => (
                                <Checkbox {...getToggleAllRowsSelectedProps()} />
                            ),
                            Cell: ({ row }) => <Checkbox {...row.getToggleRowSelectedProps()} />
                        },
                        ...columns
                    ])
                }

            )
            var new_arr_data = selectedFlatRows.map(row => row.original);
            var s_bill = selectedFlatRows.length;
            assign_arr = new_arr_data;



            const { pageIndex, pageSize, globalFilter, selectedFile } = state
            const firstPageRows = rows.slice(0, 10)

            return (
                <>
                    <p style={{ fontWeight: "bold", marginBottom: 0 }}>Stock Transfer Details</p>
                    <hr style={{ marginTop: 0 }} />
                    <div style={{ textAlign: "right", paddingBottom: "5px", marginTop: "-10px" }}><GlobalFilter filter={globalFilter} setFilter={setGlobalFilter} /></div>
                    <table id="customers" style={{ width: "100%" }}{...getTableProps()}>
                        <thead>
                            {headerGroups.map(headerGroup => (
                                <tr {...headerGroup.getHeaderGroupProps()}>
                                    {headerGroup.headers.map(column => (
                                        <th style={{ textAlign: "center" }} {...column.getHeaderProps(column.getSortByToggleProps())}>{column.render('Header')}
                                            <span>
                                                {column.isSorted
                                                    ? column.isSortedDesc
                                                        ? ' 🔽'
                                                        : ' 🔼'
                                                    : ''}
                                            </span>
                                        </th>
                                    ))}
                                </tr>
                            ))}
                        </thead>
                        <tbody {...getTableBodyProps()}>
                            {page.map(row => {
                                prepareRow(row)
                                return (
                                    <tr {...row.getRowProps()}>
                                        {row.cells.map(cell => {
                                            return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                                        })}
                                    </tr>
                                )
                            })}
                        </tbody>

                    </table>

                </>

            )
        }


        const selectedOptionsStyles = {
            color: "#3c763d",
            backgroundColor: "#dff0d8",
        };
        const optionsListStyles = {
            backgroundColor: "#dff0d8",
            color: "#3c763d",
        };


        return (
            <Col xl={12}>
                {this.state.loading_overlay && <LoadingOverlay active={true} spinner text='' />}
                <Card>
                    <CardBody style={{ height: 90 }}>
                        <form className="form form--inline" onSubmit={handleSubmit}>


                            <div
                                className="form__form-group col-xl-4"
                                style={{ marginBottom: "0px", }}
                            >
                                <div
                                    className="form__form-group-field"
                                    
                                >
                                    <select
                                        className="form-control"
                                        style={{ fontSize: 13, width: 310, marginRight: 20, height: 45 }}
                                        onChange={this.changeFromLocation}

                                    >
                                        <option value={this.state.selectedLocation}>{this.state.selectedLocation}</option>

                                    </select>
                                    <select
                                        className="form-control select_style"
                                        style={{ fontSize: 13, width: 310, marginRight: 20 }}
                                        onChange={this.changeToLocation}

                                    >
                                        <option value="">To Location</option>
                                        {this.state.location_list &&
                                            this.state.location_list.length > 0 &&
                                            this.state.location_list.map((location_list) => {
                                                return (
                                                    <option value={location_list.name}>
                                                        {" "}
                                                        {location_list.name}
                                                    </option>
                                                );
                                            })}
                                        </select>
                                </div>
                            </div>
                            <div
                                style={{ width: '12%', marginBottom: '0px', float: 'left', marginRight: 5 }}
                            >
                                <div
                                    className="form__form-group-field"

                                >
                                    <input type="text" style={{ height: 38 }} className="form-control" placeholder="Client" onChange={this.onClientChange} />
                                </div>
                            </div>

                            <div className="form__form-group col-xl-1">
                                <ButtonToolbar className="form__button-toolbar">
                                    <button
                                        color="primary"
                                        className="btn-sm button_enable "
                                        style={{
                                            width : '100px',
                                            fontWeight: "normal",
                                            textTransform: "capitalize",
                                            borderRadius: 5,
                                            backgroundColor: "#70bbfd",
                                            color: "#fff",
                                            padding: "5px 25px",
                                            //marginLeft : "120px",
                                            fontSize: "14px",
                                        }}
                                        id="button_enable"
                                        onClick={this.getProductDetails}
                                        disabled={this.state.btnDisabled}
                                    >
                                        {this.state.loading && (
                                            <i
                                                className="fa fa-refresh fa-spin"
                                                style={{ marginRight: "5px" }}
                                            />
                                        )}
                                        View
                                    </button>
                                </ButtonToolbar>
                            </div>

                            <div className="form__form-group col-xl-3">
                                <ButtonToolbar className="form__button-toolbar">
                                    <button
                                        color="primary"
                                        className="btn-sm button_enable "
                                        style={{
                                            marginLeft : "20px",
                                            fontWeight: "normal",
                                            textTransform: "capitalize",
                                            borderRadius: 5,
                                            backgroundColor: "#70bbfd",
                                            color: "#fff",
                                            padding: "5px 25px",
                                            fontSize: "14px",
                                        }}
                                        id="button_enable"
                                        onClick={()=>this.GenerateStockId('normal')}
                                        disabled={this.state.btnDisabled}
                                    >
                                        {this.state.loading_s && (
                                            <i
                                                className="fa fa-refresh fa-spin"
                                                style={{ marginRight: "5px" }}
                                            />
                                        )}
                                        Create Stock Transfer
                                    </button>
                                </ButtonToolbar>
                                        </div>


                            {/* <div className="form__form-group col-xl-8">
                                <div  style={{marginTop:20, textAlign: 'center'}}>
                                    <span style={{fontWeight: 'bold'}}>OR</span>
                                </div>
                            </div>
                            <div className="form__form-group col-xl-4">
                                <div  style={{marginTop:20, textAlign: 'center'}}>
            
                                </div>
                            </div>

                            <div className="form__form-group col-xl-5">
                                <div className="form__form-group-field">
                                {!this.state.selectedFile ? (
                                          <div
                                            style={{
                                              display: 'flex',
                                              border: '1px solid #E4E4E7',
                                              padding: '10px 12px',
                                              borderRadius: '10px',
                                              alignItems: 'center',
                                              minWidth: 300,
                                              maxWidth: 400,
                                            }}
                                          >
                                            <span style={{ fontSize: 13, color: '#7C7C85', flex: 1 }}>Upload documents in .XLS</span>
                                            <input
                                              type="file"
                                              accept=".xls,.xlsx"
                                              style={{ display: 'none' }}
                                              id="fileUpload"
                                              onChange={this.handleFileUpload}
                                            />
                                            

                                            <label htmlFor="fileUpload" style={{ fontSize: 12, color: '#121212', padding: '6px 15px', border: '1px solid #FFCB05', borderRadius: 8, cursor: 'pointer' }}>
                                              <img src={blackUploadIcon} style={{width: '22%'}} /> Attach
                                            </label>
                                          </div>
                                        ) : (
                                          <div
                                            style={{
                                              display: 'flex',
                                              alignItems: 'center',
                                              border: '1px solid #E4E4E7',
                                              padding: '8px 12px',
                                              borderRadius: '10px',
                                              backgroundColor: '#F2F4F7',
                                              minWidth: 300,
                                              maxWidth: 400,
                                            }}
                                          >
                                            <span style={{ color: '#1E90FF', fontSize: 13, flex: 1 }}>
                                              {this.state.selectedFile.name}
                                            </span>
                                            <button
                                              onClick={this.removeUploadedFile}
                                              style={{
                                                border: 'none',
                                                background: 'transparent',
                                                cursor: 'pointer',
                                                fontSize: 16,
                                                color: '#777',
                                              }}
                                            >
                                              ✖
                                            </button>
                                          </div>
                                        )}
                                        <a
                                           onClick={(e) =>
                                            exportToCSVNew(
                                              this.state.stock_header,
                                              "Stock_Transfer_Template"
                                            )
                                          }
                                            download
                                            style={{
                                              fontSize: 13,
                                              color: '#33A0FF',
                                              textDecoration: 'none',
                                              marginLeft: 15,
                                              marginRight : 20,
                                              width: '310',
                                              marginTop: 32
                                            }}
                                          >
                                            <img src={blueDownloadIcon} style={{width: '11%', marginRight:5}} />
                                             Download Sample
                                            
                                        </a>
                                </div>
                            </div>
                            <div className="form__form-group col-xl-2">
                                <div className="form__form-group-field" style={{marginTop:12}}>
                                    <select
                                        className="form-control select_style"
                                        style={{ fontSize: 13, width: 310, marginRight: 20 }}
                                        onChange={this.changeToLocation}

                                    >
                                        <option value="">To Location</option>
                                        {this.state.location_list &&
                                            this.state.location_list.length > 0 &&
                                            this.state.location_list.map((location_list) => {
                                                return (
                                                    <option value={location_list.name}>
                                                        {" "}
                                                        {location_list.name}
                                                    </option>
                                                );
                                        })}
                                    </select>

                                </div>
                            </div>

                            <div className="form__form-group col-xl-2">
                                <div className="form__form-group-field" style={{marginTop:12}}>
                                    <input type="text" style={{ height: 38 }} className="form-control" placeholder="Client" onChange={this.onClientChange} />
                                </div>
                            </div>

                            
                            <div className="form__form-group col-xl-3">
                                <ButtonToolbar className="form__button-toolbar" style={{marginTop:12}}>
                                    <button
                                        color="primary"
                                        className="btn-sm button_enable "
                                        style={{
                                            fontWeight: "normal",
                                            textTransform: "capitalize",
                                            borderRadius: 5,
                                            backgroundColor: "#70bbfd",
                                            color: "#fff",
                                            padding: "5px 25px",
                                            marginTop : "12px",
                                            fontSize: "14px",
                                        }}
                                        id="button_enable"
                                        onClick={()=>this.GenerateStockId('upload')}
                                        disabled={this.state.btnDisabled}
                                    >
                                        {this.state.loading_s1 && (
                                            <i
                                                className="fa fa-refresh fa-spin"
                                                style={{ marginRight: "5px" }}
                                            />
                                        )}
                                        Create Stock Transfer
                                    </button>
                                </ButtonToolbar>
                            </div> */}
                        </form>
                    </CardBody>


                    <CardBody style={{ marginTop: 5 }}>
                        <div
                            className="dispatchData stock_check_data style_table"
                            style={{ marginTop: 1 }}
                        >

                            <PaginationTable />
                        </div>
                    </CardBody>

                </Card>
                <Modal isOpen={successModal} toggle={this.successModal}>
                    <div className="modal__header">
                        <button
                            className="lnr lnr-cross modal__close-btn"
                            type="button"
                            style={{ right: 15 }}
                            onClick={this.successModal}
                        />
                    </div>
                    <div
                        className="modal__body"
                        style={{ paddingTop: 55, paddingBottom: 20 }}
                    >
                        <span
                            className="lnr lnr-thumbs-up modal__title-icon"
                            style={{ color: "#4ce1b6" }}
                        />
                        <h4>{this.state.success_message}</h4>
                    </div>
                    <ButtonToolbar className="modal__footer">
                        <Button
                            style={{ backgroundColor: "#24d6a3", color: "#fff" }}
                            className="modal_ok"
                            onClick={this.successToggleOK}
                        >
                            Ok
                        </Button>
                    </ButtonToolbar>
                </Modal>
                <Modal isOpen={modalfailed} toggle={this.modalfailed}>
                    <div className="modal__header">
                        <button
                            className="lnr lnr-cross modal__close-btn"
                            type="button"
                            style={{ right: 15 }}
                            onClick={this.modalfailed}
                        />
                    </div>
                    <div
                        className="modal__body"
                        style={{ paddingTop: 55, paddingBottom: 20 }}
                    >
                        <span
                            className="lnr lnr-thumbs-down modal__title-icon"
                            style={{ color: "red" }}
                        />
                        <h4>{this.state.failed_message}</h4>
                    </div>
                    <ButtonToolbar className="modal__footer">
                        <Button
                            style={{ backgroundColor: "#24d6a3", color: "#fff" }}
                            className="modal_ok"
                            onClick={this.failedToggle}
                        >
                            Ok
                        </Button>
                    </ButtonToolbar>
                </Modal>
                <Modal isOpen={alertmodal} toggle={this.alertmodal}>
                    <div className="modal__header">
                        <button
                            className="lnr lnr-cross modal__close-btn"
                            type="button"
                            style={{ right: 15 }}
                            onClick={this.alertmodal}
                        />
                    </div>
                    <div
                        className="modal__body"
                        style={{ paddingTop: 55, paddingBottom: 20 }}
                    >
                        <span
                            className="lnr lnr-thumbs-down modal__title-icon"
                            style={{ color: "red" }}
                        />
                        <h4>Please Select To Location</h4>
                    </div>
                    <ButtonToolbar className="modal__footer">
                        <Button
                            style={{ backgroundColor: "#24d6a3", color: "#fff" }}
                            className="modal_ok"
                            onClick={this.alertToggle}
                        >
                            Ok
                        </Button>
                    </ButtonToolbar>
                </Modal>
            </Col>
        );
    }
}

export default reduxForm({
    form: "Upload Master", // a unique identifier for this form
})(withTranslation("common")(HorizontalForm));
